<div nz-flex [nzJustify]="'center'" [nzAlign]="'flex-end'" nzGap="10px">
  <div class="our-community-list">
    <div nz-dropdown [nzDropdownMenu]="menu" nzTrigger="click" nzClickHide="true">
      <button nz-button nzType="default" nzShape="circle" class="logout-btn">
        <nz-icon nzType="user" nzTheme="outline" /></button
      >&nbsp;
      <span class="d-none d-md-inline">{{ userName }}</span>
    </div>
    <nz-dropdown-menu #menu="nzDropdownMenu" class="insurance-header-menu">
      <ul nz-menu class="common-header-menu">
        @if (visibilityStatus('general', 'user')) {
          <li nz-menu-item (click)="goToUserInfo()">
            <nz-icon class="me-2" nzType="profile" nzTheme="outline" />
            Profile
          </li>
        }
        <li nz-menu-item (click)="onClickResetPassword()">
          <nz-icon class="me-2" nzType="lock" nzTheme="outline" />
          Password Reset
        </li>
        @if (visibilityStatus('general', 'about')) {
          <li nz-menu-item (click)="showModal()">
            <nz-icon class="me-2" nzType="setting" nzTheme="outline" />
            About
          </li>
        }
        <li nz-menu-item (click)="logout()">
          <nz-icon class="me-2" nzType="logout" nzTheme="outline" />
          Logout
        </li>
      </ul>
    </nz-dropdown-menu>
  </div>
</div>
<ng-template #customAboutPopupFooter>
  <button nz-button nzType="default" class="btn-secondary" nzSize="small" (click)="handleCancel()">
    Close
  </button>
</ng-template>
<ng-template #resetPasswordFooter>
  <div nzAlign="end" nzJustify="flex-end" nz-flex [nzGap]="'10px'" [nzWrap]="'wrap'">
    <button
      nz-button
      nzType="default"
      nzSize="small"
      class="btn-secondary me-0"
      (click)="handleCancel()"
    >
      Cancel
    </button>
    <!-- (click)='' -->
    <button
      nz-button
      nzSize="small"
      (click)="handlePasswordReset()"
      nzType="primary"
      class="btn-primary"
      [nzLoading]="loader"
    >
      Save
    </button>
  </div>
</ng-template>
